import reduce from 'lodash/reduce';

import { BaseSubscription } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/ResponseDto';

import { TBaseSubscription } from '~/src/features/tariffBuilder/reducer/initialState';

const prepareBaseSubscription = (current: Record<number, TBaseSubscription>, incoming: { entities: Record<number, BaseSubscription>}, selectedVases: number[]) => {
    return reduce(incoming.entities, (result, incomingSubscription, key) => {
        const {
            id,
            images,

            oldCost,
            deltaCost,
            cost,

            ...subscription
        } = incomingSubscription;

        const isSelectedByResponse = selectedVases.includes(id);

        const numericId = Number(key);
        const finalCost = {
            previous: oldCost,
            fact: deltaCost,
            final: cost,
        };
        if (!result[numericId]) {
            result[numericId] = {
                ...subscription,
                id: Number(id),
                cost: finalCost,
                imagePath: images,
                quantity: isSelectedByResponse ? 1 : 0,
            };
        } else {
            result[numericId] = {
                ...result[numericId],
                cost: finalCost,
            };
        }

        return result;
    }, current);
};

export default prepareBaseSubscription;
